export const parseProductHandle = (productUrl: string): string => {
  return productUrl.replace("/products/", "");
};
